import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { GsStructBorderRadius, GsStructBorderStyle } from '../../../models';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { borderSchemaFields } from './../basics/border.schema';
import { colorBackgroundGeneratorSchema } from './../basics/colorSchema.schema';
import { DISPLAY_MODE_SCHEMA } from './../basics/display-mode.schema';
import { pictureDisplayModeSchemaFor } from './../basics/picture-display-mode.schema';
import { Mode, SWIPER_SCHEMA_FIELDS } from './../basics/swiper.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the partner component form.
 * Defines the fields to display for the form.
 */

export const PARTNER_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'itemPadding',
      label: 'components.partner.schema.itemPadding',
      type: 'padding',
      useTailwindClasses: true,
      groupingName: 'schema.items.name',
      default: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
      }
    },
    {
      formControlName: 'itemImageHeight',
      label: 'components.partner.schema.itemImageHeight',
      type: 'number',
      groupingName: 'schema.items.name',
      isResponsive: true,
      default: { default: 200 }
    },
    pictureDisplayModeSchemaFor('pictureDisplayMode', undefined, undefined, 'schema.items.name'),
    ...colorBackgroundGeneratorSchema('item', undefined, undefined, undefined, 'schema.items.name'),
    {
      formControlName: 'itemsGap',
      label: 'components.partner.schema.gapSize',
      type: 'select',
      default: 1,
      valueType: 'number',
      options: [
        { text: '0', value: 0 },
        { text: '2px', value: 0.5 },
        { text: '4px', value: 1 },
        { text: '6px', value: 1.5 },
        { text: '8px', value: 2 },
        { text: '16px', value: 4 },
        { text: '24px', value: 6 },
        { text: '32px', value: 8 }
      ]
    },
    ...borderSchemaFields(undefined, {
      borderRadius: GsStructBorderRadius.xl,
      borderStyle: GsStructBorderStyle.none
    }),
    {
      formControlName: 'sliderColumns',
      label: 'schema.items.rowsOfItems',
      type: 'number',
      groupingName: 'Slider options',
      default: 2,
      min: 1,
      if: {
        args: [
          {
            formControlName: 'mode',
            value: Mode.SLIDER
          }
        ]
      }
    },
    ...SWIPER_SCHEMA_FIELDS
  ]
};
